export type VisibilityState = Record<string, boolean>;

export const rmaColumnVisibilityItems: VisibilityState = {
  slNo: true,
  BfsBenfId: true,
  BfsBenfTxnTime: false,
  BfsBfsTxnId: true,
  BfsBfsTxnTime: false,
  BfsDebitAuthCode: false,
  BfsDebitAuthNo: false,
  BfsMsgType: false,
  BfsOrderNo: false,
  BfsRemitterBankId: true,
  BfsRemitterName: true,
  BfsTxnAmount: true,
  BfsTxnCurrency: true,
  MembershipDurationId: false,
  UserId: false,
  // Example of hiding a column (just like you did with email)
  // BfsRemitterName: false,
};
